exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* Colors */\n/* Borders */\n/* Media */\n/* \n    420px because it will not allow 3 buttons\n    at 30% with 10px margins to be displayed \n    on a single line.\n*/\n/* Common sizes */\n/* z indices */\n.cs-Checklist {\n  max-width: 100%;\n}\n.cs-Checklist__question {\n  margin: 20px 0;\n  font-size: 18px;\n}\n.cs-Checklist__list {\n  margin: 20px;\n  margin-bottom: 10px;\n  padding: 15px;\n  border: 1px solid #ccc;\n  font-size: 16px;\n  border-radius: 4px;\n  list-style: none;\n}\n.cs-Checklist__list-item__label {\n  padding: 10px 0 10px 25px;\n  text-indent: -30px;\n  cursor: pointer;\n}\n/* Element selector required because of bootstrap */\ninput.cs-Checklist__checkbox {\n  position: relative;\n  width: 20px;\n  height: 20px;\n  top: 4px;\n  margin-right: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/Checklist/Checklist.less
// module id = 874
// module chunks = 0